// Hoe ver kwam een interviewproces (eigenaarsbesluit 23 oktober 2026)? Een
// afgewezen proces zei overal alleen 'Afgewezen', zodat een kandidaat die na het
// tweede gesprek afviel er hetzelfde uitzag als een die na de CV Send afviel. EEN
// regel, in JS en in SQL: de hoogste ronde met een datum (iv1Date..iv6Date), en een
// aanbieding gaat voor: een stempel (aanbiedingAt) of de status Aanbieding
// arbeidscontract, want die status zetten schrijft geen stempel. Getekend telt niet
// als aanbieding. Dezelfde velden als de Fase-kaart (lib/placement-rail.mjs).
//
// Puur: geen database, geen alias-imports.

// Haalde dit proces de aanbieding?
export function offerReached(d) {
  return !!d.aanbiedingAt || d.status === 'Aanbieding arbeidscontract';
}

// 'aanbieding', 'iv6'..'iv1', of null als er geen ronde een datum draagt.
// processSummary (lib/processen-rows.mjs) rekent hem een keer uit en geeft hem als
// `reached` mee; een rij die hem al draagt, wordt niet opnieuw gelezen.
export function processReached(d) {
  if (!d) return null;
  if (d.reached !== undefined) return d.reached;
  if (offerReached(d)) return 'aanbieding';
  for (let i = 6; i >= 1; i -= 1) if (d[`iv${i}Date`]) return `iv${i}`;
  return null;
}

// Het afwijslabel bij een bereikte stand. `label` is het korte woord voor de
// statuskolom, `title` de volle zin voor de tooltip. 'cv' is een CV Send die werd
// afgewezen voordat er een proces was.
export function rejectedStage(reached) {
  if (reached === 'cv') return { label: 'Afgewezen, CV', title: 'Afgewezen na CV Send' };
  if (reached === 'aanbieding') return { label: 'Afgewezen, aanb.', title: 'Afgewezen na aanbieding' };
  const m = /^iv([1-6])$/.exec(String(reached || ''));
  if (m) return { label: `Afgewezen, IV${m[1]}`, title: `Afgewezen na Interview ${m[1]}` };
  return { label: 'Afgewezen, geen IV', title: 'Afgewezen voor Interview 1' };
}

// Het filter Bereikt in het procesraster. IV3 tot en met IV6 vallen samen. Een sourcingproces, en een interviewproces zonder ronde met datum, staat
// op CV Send: het begon met een CV Send en kwam niet verder.
export const REACHED_OPTIONS = Object.freeze([
  { value: 'CV Send', label: 'CV Send' },
  { value: 'Interview 1', label: 'Interview 1' },
  { value: 'Interview 2', label: 'Interview 2' },
  { value: 'Interview 3+', label: 'Interview 3+' },
  { value: 'Aanbieding', label: 'Aanbieding' },
]);

// De filterwaarde van een deal (JS-tweeling van processReachedSql). Alleen een
// interviewproces heeft rondes; een sourcingproces staat op CV Send, BD levert ''.
export function processReachedBucket(d) {
  if (!d) return '';
  if (d.track === 'sourcing') return 'CV Send';
  if (d.track && d.track !== 'placement') return '';
  const r = processReached(d);
  if (r === 'aanbieding') return 'Aanbieding';
  if (r === 'iv1') return 'Interview 1';
  if (r === 'iv2') return 'Interview 2';
  if (r) return 'Interview 3+';
  return 'CV Send';
}

// Dezelfde regel in SQL op de jsonb van een deals-rij (`alias`.data). Een lege
// string telt als geen datum, net als in JS.
export function processReachedSql(alias = 'p') {
  const has = (k) => `NULLIF(${alias}.data->>'${k}', '') IS NOT NULL`;
  return `(CASE WHEN ${alias}.data->>'track' = 'sourcing' THEN 'CV Send'`
    + ` WHEN COALESCE(${alias}.data->>'track', 'placement') <> 'placement' THEN NULL`
    + ` WHEN ${has('aanbiedingAt')} OR ${alias}.data->>'status' = 'Aanbieding arbeidscontract' THEN 'Aanbieding'`
    + ` WHEN ${has('iv3Date')} OR ${has('iv4Date')} OR ${has('iv5Date')} OR ${has('iv6Date')} THEN 'Interview 3+'`
    + ` WHEN ${has('iv2Date')} THEN 'Interview 2'`
    + ` WHEN ${has('iv1Date')} THEN 'Interview 1'`
    + ` ELSE 'CV Send' END)`;
}
